import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <form>
  <div class="control-group">
    <ComboBox
      @onChange={{@onChangeStatusType}}
      @content={{@timerTypes}}
      @value={{this.statusType}}
      class="timer-type"
    />
  </div>

  {{#if this.publishToCategory}}
    <div class="control-group">
      <label class="control-label">
        {{i18n "topic.topic_status_update.publish_to"}}
      </label>
      <CategoryChooser
        @value={{@topicTimer.category_id}}
        @onChange={{fn (mut @topicTimer.category_id)}}
        @options={{hash excludeCategoryId=this.excludeCategoryId}}
      />
    </div>
  {{/if}}

  {{#if this.showFutureDateInput}}
    <label class="control-label">
      {{i18n "topic.topic_status_update.when"}}
    </label>
    <TimeShortcutPicker
      @timeShortcuts={{this.timeOptions}}
      @prefilledDatetime={{@topicTimer.execute_at}}
      @onTimeSelected={{this.onTimeSelected}}
      @hiddenOptions={{this.hiddenTimeShortcutOptions}}
      @_itsatrap={{this._itsatrap}}
    />
  {{/if}}

  {{#if this.useDuration}}
    <div class="controls">
      <label class="control-label">
        {{i18n "topic.topic_status_update.duration"}}
      </label>
      <RelativeTimePicker
        @onChange={{this.changeDuration}}
        @durationMinutes={{@topicTimer.duration_minutes}}
      />
    </div>
  {{/if}}

  {{#if this.willCloseImmediately}}
    <div class="warning">
      {{d-icon "exclamation-triangle"}}
      {{this.willCloseI18n}}
    </div>
  {{/if}}

  {{#if this.showTopicTimerInfo}}
    <div class="alert alert-info modal-topic-timer-info">
      <TopicTimerInfo
        @statusType={{this.statusType}}
        @executeAt={{this.executeAt}}
        @basedOnLastPost={{@topicTimer.based_on_last_post}}
        @durationMinutes={{@topicTimer.duration_minutes}}
        @categoryId={{@topicTimer.category_id}}
      />
    </div>
  {{/if}}
</form>
*/
{
  "id": "kPIyuNto",
  "block": "[[[10,\"form\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n    \"],[8,[39,0],[[24,0,\"timer-type\"]],[[\"@onChange\",\"@content\",\"@value\"],[[30,1],[30,2],[30,0,[\"statusType\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"publishToCategory\"]],[[[1,\"    \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"topic.topic_status_update.publish_to\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,3],null,[[\"@value\",\"@onChange\",\"@options\"],[[30,3,[\"category_id\"]],[28,[37,4],[[28,[37,5],[[30,3,[\"category_id\"]]],null]],null],[28,[37,6],null,[[\"excludeCategoryId\"],[[30,0,[\"excludeCategoryId\"]]]]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showFutureDateInput\"]],[[[1,\"    \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"topic.topic_status_update.when\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,7],null,[[\"@timeShortcuts\",\"@prefilledDatetime\",\"@onTimeSelected\",\"@hiddenOptions\",\"@_itsatrap\"],[[30,0,[\"timeOptions\"]],[30,3,[\"execute_at\"]],[30,0,[\"onTimeSelected\"]],[30,0,[\"hiddenTimeShortcutOptions\"]],[30,0,[\"_itsatrap\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"useDuration\"]],[[[1,\"    \"],[10,0],[14,0,\"controls\"],[12],[1,\"\\n      \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"topic.topic_status_update.duration\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,8],null,[[\"@onChange\",\"@durationMinutes\"],[[30,0,[\"changeDuration\"]],[30,3,[\"duration_minutes\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"willCloseImmediately\"]],[[[1,\"    \"],[10,0],[14,0,\"warning\"],[12],[1,\"\\n      \"],[1,[28,[35,9],[\"exclamation-triangle\"],null]],[1,\"\\n      \"],[1,[30,0,[\"willCloseI18n\"]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showTopicTimerInfo\"]],[[[1,\"    \"],[10,0],[14,0,\"alert alert-info modal-topic-timer-info\"],[12],[1,\"\\n      \"],[8,[39,10],null,[[\"@statusType\",\"@executeAt\",\"@basedOnLastPost\",\"@durationMinutes\",\"@categoryId\"],[[30,0,[\"statusType\"]],[30,0,[\"executeAt\"]],[30,3,[\"based_on_last_post\"]],[30,3,[\"duration_minutes\"]],[30,3,[\"category_id\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13]],[\"@onChangeStatusType\",\"@timerTypes\",\"@topicTimer\"],false,[\"combo-box\",\"if\",\"i18n\",\"category-chooser\",\"fn\",\"mut\",\"hash\",\"time-shortcut-picker\",\"relative-time-picker\",\"d-icon\",\"topic-timer-info\"]]",
  "moduleName": "discourse/components/edit-topic-timer-form.hbs",
  "isStrictMode": false
});